import _ from 'lodash'
import root from './root'
import version from './version'
import history from './history'
import { DATALAYER } from './eventTypes'

const DATA_KEY = 'data'

root[DATA_KEY] = root[DATA_KEY] || {}

// Store version in data layer
root[DATA_KEY]._trackerLibVersion = version

const createPath = path => `${DATA_KEY}${path ? '.' + path : ''}`

const set = ({ data = {}, path, event = 'updateDataLayer' }) => {
  // Update data layer
  const update = _.set({}, createPath(path), data)
  _.merge(root, update)

  // Push to history
  const type = DATALAYER.UPDATED
  history.push({ data, path, event, type })

  // Log and dispatch
  window.dispatchEvent(new CustomEvent(type))
}

const get = (path) => {
  return _.get(root, createPath(path))
}

export default { get, set }
